/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryDto as DigiworkMaitreDPosDtoInventoryInventoryDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-dto';

export interface GetInventory$Params {
  inventoryId: string;
}

export function getInventory(http: HttpClient, rootUrl: string, params: GetInventory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryDto>> {
  const rb = new RequestBuilder(rootUrl, getInventory.PATH, 'get');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryDto>;
    })
  );
}

getInventory.PATH = '/api/inventories/{inventoryId}';
